export const DISMISSED_OFFLINE_MAP_UPDATE_VERSION_KEY = 'lvb.offlineMap.dismissedUpdateVersion';

import { userIsAdmin } from '@/utils/userRoles';

// Re-exported: these modules are the existing import site for it.
export { userIsAdmin };

export function getDismissedOfflineMapUpdateVersion(storage) {
  if (!storage) return null;
  try {
    return storage.getItem(DISMISSED_OFFLINE_MAP_UPDATE_VERSION_KEY);
  } catch {
    return null;
  }
}

export function dismissOfflineMapUpdateVersion(version, storage) {
  if (!storage || !version) return false;
  try {
    storage.setItem(DISMISSED_OFFLINE_MAP_UPDATE_VERSION_KEY, version);
    return true;
  } catch {
    return false;
  }
}

export function shouldShowOfflineMapUpdateNotice({
  updateStatus,
  user,
  dismissedVersion,
  desktopApp,
} = {}) {
  const publishedVersion = updateStatus?.published?.version;

  return Boolean(
    desktopApp
    && userIsAdmin(user)
    && updateStatus?.status === 'update_available'
    && publishedVersion
    && publishedVersion !== dismissedVersion
  );
}
